
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificates/[slug]",
      function () {
        return require("private-next-pages/certificates/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificates/[slug]"])
      });
    }
  